import { render } from "./projects-image.vue?vue&type=template&id=6e581a9a"
import script from "./projects-image.vue?vue&type=script&lang=js"
export * from "./projects-image.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__